import { AnimatePresence, motion } from 'framer-motion'
import React from 'react'
import BackgroundImage from '@/assets/background-image.png'
import { Column, Row, Show } from '@/components/core'

interface SetupContainerProps {
  botAvatar?: string
  children: React.ReactNode
  variant?: 'image' | 'icon'
  animate?: boolean
}

const AvatarCard = ({
  botAvatar,
  children,
  variant = 'image',
  animate = true
}: SetupContainerProps) => {
  return (
    <Column className="relative flex h-full w-full flex-col overflow-hidden bg-white lg:h-[70%] lg:min-h-[620px] lg:w-[80%] lg:rounded-2xl">
      <AnimatePresence>
        <motion.div
          key="setup-container"
          initial={animate ? { opacity: 0 } : { opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          style={{ flex: 1 }}
        >
          <Show
            when={variant === 'image'}
            fallback={
              <Column className="h-full">
                <Column className="relative h-[128px] bg-electric-indigo-50 md:rounded-tl-2xl md:rounded-tr-2xl">
                  <img
                    src={BackgroundImage}
                    alt="bot-image"
                    sizes="720"
                    className="h-full w-full overflow-hidden rounded-full object-fill"
                  />
                  <Row className="absolute -bottom-14 h-[106px] w-[106px] self-center">
                    <img
                      src={botAvatar}
                      alt="bot-avatar-icon"
                      sizes="150"
                      className="h-full w-full overflow-hidden rounded-full object-contain"
                    />
                  </Row>
                </Column>
                <Column className="flex-1 justify-center px-8 pb-10 pt-24 md:px-20">
                  {children}
                </Column>
              </Column>
            }
          >
            <Column className="h-full">
              {!!botAvatar && (
                <Column className="relative h-[calc(40vw)] md:h-[288px]">
                  <img
                    src={botAvatar}
                    alt="bot-image"
                    sizes="150"
                    className="h-auto w-full overflow-hidden object-cover"
                  />
                </Column>
              )}
              <Column className="flex-1 px-8 pb-10 pt-14 md:px-[72px]">
                {children}
              </Column>
            </Column>
          </Show>
        </motion.div>
      </AnimatePresence>
    </Column>
  )
}

export default AvatarCard
